import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getJson } from '~shared/utils/http';
import { buildSpectateUrl } from '~spa/Utils/Spectate';
import ModalWindow from '~shared/components/modal-overlay/ModalWindow';
import ArticleCard from './ArticleCard';
import { MODAL_TYPES } from '~shared/components/modal-overlay/constants.js';
import { useModal } from '~shared/components/modal-overlay/ModalContext';
import { getArticleImage, getDayHour } from '../utils/utils';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '~shared/components/react/LoadingIndicator/index';
import '../styles/article-modal.scss';
import ArticleTextViewer from './ArticleTextViewer';

const ArticleModal = ({
    articleId,
    gtmCategory,
}) => {

    const [articledData, setArticleData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [ t ] = useTranslation();
    const { removeModalsWithId } = useModal();

    useEffect(() => {
        const getArticle = async () => {
            const response = await getJson(buildSpectateUrl(`/article-req/getArticle/${articleId}`));
            if (response && response.ok) {
                const responseJson = await response.json();
                setArticleData(responseJson.article_data);
                setIsLoading(false);
            }
        };
        getArticle();
    }, []);

    const {
        filename,
        timediff,
        title,
        author,
        image_credit,
        event_name,
    } = articledData;

    const imageUrl = getArticleImage(filename);

    const inlineImage = {
        backgroundImage: `url(${imageUrl})`,
    };

    const timeDiffText = getDayHour(timediff, t);

    return (
        <ModalWindow
            title={t('long_articles_widget.header')}
            handleClose = {() => removeModalsWithId(MODAL_TYPES.LONG_ARTICLE)}
            modalOverrideClass="article"
            iconClass='article-icon'
        >
        <div className='article-modal'>
            {isLoading &&
                <LoadingIndicator/>
            }
            {!isLoading &&
            <div className="article-modal--scrollable">
                <div className='article-container'>
                    <ArticleCard
                        title={title}
                        author={author}
                        timeDiffText={timeDiffText}
                        inlineImage={inlineImage}
                        imageCreds={image_credit}
                        eventName={event_name}
                    />
                </div>
                <ArticleTextViewer
                    gtmCategory={gtmCategory}
                    {...articledData}
                />
            </div>
            }
        </div>
        </ModalWindow>
    );
};

ArticleModal.propTypes = {
    articleId: PropTypes.string.isRequired,
    gtmCategory: PropTypes.string,
};

export default ArticleModal;
